// import React from 'react'
// import styled from 'styled-components'
// import { DateIcon, DownArrow, ProfileImg, UserIcon } from '../utils/Images'
// import { ProfileBg } from "../utils/Images"
// import { DatePicker } from 'antd'
// import { addsubuser } from '../collection/ApiCollection'
// import { toast } from 'react-toastify'

// const CreateProfile = () => {
//     const onChange = (date, dateString) => {
//         console.log(date, dateString);
//     };

//     const handleSubmit = async () => {
//         let res = await addsubuser();
//         if (res.status === 200) {
//             toast.success(res?.message)
//         } else {
//             toast.error(res?.reponse?.data?.message || res?.error || res?.message || "Something went wrong")
//         }
//     }

//     return (
//         <CreateProfileWrapper>
//             <div className='content'>
//                 <h1 className='profile-heading'>Let’s create a Sub-Profile</h1>
//                 <div className='profile-content'>
//                     <img src={ProfileImg} alt="" />
//                     <p>+ Add Profile Image</p>
//                 </div>
//                 <div className='input-div'>
//                     <div>
//                         <img src={UserIcon} alt="" className='mail-icon' />
//                         <input type='text' name='text' placeholder='Full name' />
//                     </div>
//                 </div>
//                 <DatePicker placeholder='Date of Birth' onChange={onChange} style={{ height: "70px", width: "100%", borderRadius: "12px", padding: "0px 23px", marginTop: "31px" }} suffixIcon={<img src={DateIcon} alt="" width={24} height={24} />} />
//                 <div className="select-container">
//                     <select className="custom-select">
//                         <option value="" disabled selected>
//                             Gender
//                         </option>
//                         <option value="male">Male</option>
//                         <option value="female">Female</option>
//                         <option value="other">Other</option>
//                     </select>
//                     <img src={DownArrow} alt="Dropdown Arrow" className="dropdown-icon" />
//                 </div>
//                 <div className='btn-div'>
//                     <button>ADD PROFILE</button>
//                 </div>
//             </div>
//         </CreateProfileWrapper>
//     )
// }

// export default CreateProfile

// const CreateProfileWrapper = styled.div`
//  background:url(${ProfileBg});
//  height:100vh;
//  display:flex;
//  align-items:center;
//  justify-content:center;
//     .content{
//         background:#fff;
//         border-radius:19px;
//         box-shadow: 0px 4px 13px 5px #00000040;
//         padding:39px;
//         max-width:465px;
//         width:100%;

//         .profile-heading{
//             font-size:22px;
//             font-weight:700;
//             text-align:center;
//         }
//         .profile-content{
//             margin-top:39px;
//             display:flex;
//             flex-direction:column;
//             align-items:center;
//             gap:16px;

//             img{
//                 width:128px;
//                 height:128px;
//             }
//             p{
//                 font-weight:500;
//                 color:#0DA982;
//                 font-size:18px;
//                 cursor:pointer;
//             }
//         }
//         .input-div{
//             div{
//                 margin:auto;
//                 margin-top:31px;
//                 border:1px solid #E4DFDF;
//                 border-radius:12px;
//                 height:70px;
//                 display:flex;
//                 align-items:center;
//                 gap:15px;
//                 position:relative;
//                 width:100%;

//                 .mail-icon{
//                     width:27px;
//                     height:27px;
//                     position:absolute;
//                     z-index:9;
//                     left:20px;
//                 }
//                 .eye-icon{
//                     width:29px;
//                     height:30px;
//                     position:absolute;
//                     z-index:9;
//                     right:20px;
//                 }
//                 input{
//                     font-size:14px;
//                     font-weight:400;
//                     border:none;
//                     height:100%;
//                     position:relative;
//                     padding:0px 60px;
//                     border-radius:12px;
//                     width:100%;

//                     &:focus{
//                         outline:none;
//                     }
//                 }
//             }
//         }
//         .select-container {
//             position: relative;
//             width: 100%;
//             margin-top:31px;

//             .custom-select {
//                 width: 100%;
//                 height: 70px; /* Adjust height */
//                 padding: 0 40px 0 23px; /* Add right padding to make room for the icon */
//                 font-size: 16px;
//                 border: 1px solid #e5e7eb;
//                 border-radius: 12px;
//                 background-color: #fff;
//                 color: #6b7280;
//                 appearance: none; /* Remove native dropdown arrow */
//                 -webkit-appearance: none;
//                 -moz-appearance: none;
//                 cursor: pointer;

//                 &:focus {
//                     outline: none;
//                     border-color: #3b82f6; /* Focus color */
//                     box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);
//                 }
//             }
//             .dropdown-icon {
//                 position: absolute;
//                 right: 25px;
//                 top: 50%;
//                 transform: translateY(-50%);
//                 width: 16px; /* Adjust icon size */
//                 height: auto;
//                 pointer-events: none; /* Prevent icon from blocking clicks */
//             }
//         }
//         .btn-div{
//             display:flex;
//             align-items:center;
//             justify-content:center;
//             margin-top:49px;

//             button{
//                 height:48px;
//                 background:#0DA982;
//                 color:#fff;
//                 font-size:16px;
//                 font-weight:700;
//                 border:none;
//                 max-width:225px;
//                 width:100%;
//                 border-radius:15px;
//                 cursor:pointer;
//             }
//         }
//     }
// `

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DateIcon, DefaultProfile, DownArrow, UserIcon } from "../utils/Images";
import { ProfileBg } from "../utils/Images";
import { DatePicker } from "antd";
import { addsubuser, getpaymentmethods, setdefaultsubuser } from "../collection/ApiCollection";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { subUser } from "../store/SubUserId";
import { cousntryCodesArr } from "../utils/constants";
import useSelection from "antd/es/table/hooks/useSelection";
import { authlogin } from "../store/Authentication";

const CreateProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+1");
  const [numberValue, setNumberValue] = useState(null);
  const [profileImage, setProfileImage] = useState(DefaultProfile); // Preview image
  const [uploadedFile, setUploadedFile] = useState(null); // Binary file
  const [fullName, setFullName] = useState(null);
  const [date, setDate] = useState(null);
  const [loader, setLoader] = useState(null);
  const [gender, setGender] = useState(null);
  const [cardListing, setCardListing] = useState(null)
  const loginData = useSelector((stata) => stata?.Authlogin?.data);
  const isSubUser = useSelector((state) => state?.Authlogin?.data?.userDetail?.isSubUser);
  const pathname = window.location.pathname == "/landing/create-profile";

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file); // Store the binary file
      setProfileImage(URL.createObjectURL(file)); // Generate a preview URL
    }
  };

  // Date picker handler
  const onChange = (date, dateString) => {
    console.log(date, dateString);
    setDate(dateString);
  };

  const handleSubmit = async () => {
    if (!fullName) {
      toast.error("Please enter full name");
    } else if (!date) {
      toast.error("Please select date of birth");
    } else if (!gender) {
      toast.error("Please select gender");
    } else if (!uploadedFile) {
      toast.error("Please upload profile image");
    } else if (!numberValue || !countryCode) {
      toast.error("Please enter your number");
    } else if (numberValue.length < 7 || numberValue.length > 15) {
      toast.error("Enter a valid phone number (7-15 digits)!");
    } else {
      setLoader(true);
      try {
        const formData = new FormData();
        formData.append("fullName", fullName);
        formData.append("dateOfBirth", date);
        formData.append("gender", gender);
        formData.append("countryCode", countryCode);
        formData.append("phoneNumber", numberValue);
        formData.append("profileImage", uploadedFile);
        let res = await addsubuser(formData);
        if (res.status === 200) {
          // dispatch(subUser(res?.data))
          console.log(res?.data?.data?._id, "mamamam");
          if (res?.data?.data?._id) {
            try {
              let req = {
                subUserId: res?.data?.data?._id,
              };
              let ressult = await setdefaultsubuser(req);
              if (ressult.status === 200) {
                const updatedAuthLogin = {
                  ...loginData,
                  userDetail: {
                    ...loginData.userDetail,
                    isSubUser: true
                  }
                };
                dispatch(authlogin(updatedAuthLogin))
                setLoader(false);
                toast.success(res?.data?.message);
                navigate("/landing/payment");
              } else {
                setLoader(false)
                toast.error(
                  ressult?.reponse?.data?.message ||
                  ressult?.error ||
                  ressult?.message ||
                  "Something went wrong"
                );
              }
            } catch (error) {
              setLoader(false)
              toast.error(
                error?.reponse?.data?.message ||
                error?.error ||
                error?.message ||
                "Something went wrong"
              );
            }
          }
        } else {
          setLoader(false);
          toast.error(
            res?.reponse?.data?.message ||
            res?.error ||
            res?.message ||
            "Something went wrong"
          );
        }
      } catch (error) {
        setLoader(false)
        toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong");
      }
    }
  };

  const handleGetAllCard = async () => {
    try {
      let res = await getpaymentmethods();
      if (res.status === 200) {
        setCardListing(res?.data?.data)
      } else {
        setCardListing(null)
      }
    } catch (error) {
      setCardListing(null)
    }
  }

  useEffect(() => {
    if (!loginData) {
      navigate("/");
    }
  }, [loginData]);

  useEffect(() => {
    if (cardListing?.[0]?.isDefault) {
      navigate("/landing/schedule")
    }
  }, [cardListing])

  useEffect(() => {
    if (pathname && isSubUser) {
        window.location.replace("/landing/payment");
    }
}, [isSubUser,window.location])

  useEffect(() => {
    handleGetAllCard()
  }, [])


  return (
    <CreateProfileWrapper>
      <div className="content">
        <h1 className="profile-heading">Let’s create a Sub-Profile</h1>
        <div className="profile-content">
          <img src={profileImage} alt="Profile Preview" />
          <label htmlFor="file-upload" className="add-image-label">
            + Add Profile Image
          </label>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: "none" }}
          />
        </div>
        <div className="input-div">
          <div>
            <img src={UserIcon} alt="" className="mail-icon" />
            <input
              type="text"
              name="text"
              placeholder="Full name"
              onChange={(e) => setFullName(e?.target?.value)}
              required
            />
          </div>
        </div>
        <DatePicker
          placeholder="Date of Birth"
          onChange={onChange}
          prefixCls="custom-date"
          style={{
            height: "70px",
            width: "100%",
            borderRadius: "12px",
            padding: "0px 23px",
            marginTop: "31px",
          }}
          disabledDate={(current) => current && current > new Date()}
          suffixIcon={<img src={DateIcon} alt="" width={24} height={24} />}
        />
        <div className="select-container">
          <select
            className="custom-select"
            required
            onChange={(e) => setGender(e?.target?.value)}
          >
            <option value="" disabled selected hidden>
              Gender
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <img src={DownArrow} alt="Dropdown Arrow" className="dropdown-icon" />
        </div>
        <StyledFormItem
        >
          <div style={{ display: "flex", gap: "10px" }}>
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              className="country-code"
              style={{ height: "70px", borderRadius: "12px" }}
            >
              {cousntryCodesArr?.map((val) => {
                return (
                  <option value={val?.code}>
                    {val?.code} {val?.name}
                  </option>
                );
              })}
            </select>
            <input placeholder="Phone number" onChange={(e) => setNumberValue(e?.target?.value)} />
          </div>
        </StyledFormItem>
        <div className="btn-div">
          <button onClick={handleSubmit}>
            {loader ? "Loading..." : "ADD PROFILE"}
          </button>
        </div>
      </div>
    </CreateProfileWrapper>
  );
};

export default CreateProfile;

const CreateProfileWrapper = styled.div`
  background: url(${ProfileBg});
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    background: #fff;
    border-radius: 19px;
    box-shadow: 0px 4px 13px 5px #00000040;
    padding: 39px;
    max-width: 465px;
    width: 100%;
    max-height: 757px;
    height: calc(100vh - 20px);
    overflow-y: auto;

    .profile-heading {
      font-size: 22px;
      font-weight: 700;
      text-align: center;
    }

    .profile-content {
      margin-top: 39px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      img {
        width: 128px;
        height: 128px;
        border-radius: 50%;
        object-fit: cover;
      }

      .add-image-label {
        font-weight: 500;
        color: #0da982;
        font-size: 18px;
        cursor: pointer;
      }
    }

    .input-div {
      div {
        margin: auto;
        margin-top: 31px;
        border: 1px solid #e4dfdf;
        border-radius: 12px;
        height: 70px;
        display: flex;
        align-items: center;
        gap: 15px;
        position: relative;
        width: 100%;

        .mail-icon {
          width: 27px;
          height: 27px;
          position: absolute;
          z-index: 9;
          left: 20px;
        }

        input {
          font-size: 14px;
          font-weight: 400;
          border: none;
          height: 100%;
          position: relative;
          padding: 0px 60px;
          border-radius: 12px;
          width: 100%;

          &:focus {
            outline: none;
          }
        }
      }
    }

    .select-container {
      position: relative;
      width: 100%;
      margin-top: 31px;

      .custom-select {
        width: 100%;
        height: 70px;
        padding: 0 40px 0 23px;
        font-size: 16px;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        background-color: #fff;
        color: #6b7280;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;

        &:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);
        }
      }

      .dropdown-icon {
        position: absolute;
        right: 25px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: auto;
        pointer-events: none;
      }
    }

    .btn-div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 49px;

      button {
        height: 48px;
        background: #0da982;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        border: none;
        max-width: 225px;
        width: 100%;
        border-radius: 15px;
        cursor: pointer;
      }
    }
  }
`;


const StyledFormItem = styled.div`
  margin-top: 31px !important;

  input {
    height: 70px;
    border-radius: 12px;
    border: 1px solid #e4dfdf;
    border-radius: 12px;
    height: 70px;
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
    width: 100%;
    padding: 0px 20px;
        &:focus {
            outline: none;
        }
  }

  select{
    border: 1px solid #e4dfdf;
    border-radius: 12px;
    height: 70px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .ant-picker-input input::placeholder{
    color:#747688 !important;
  }
  .ant-form-item-control-input-content input::placeholder{
    color:#747688 !important;
  }
  .ant-select-selection-placeholder{
    color:#747688 !important;
  }
  .ant-select-selection-search input::placeholder{
  color:#747688 !important;
  }
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
  .ant-select-selector {
    height: 70px !important;
    border-radius: 12px;
  }
  .ant-form-item-label > label {
    color: #fff;
  }
  .btn-div {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      height: 48px;
      font-weight: 700;
      font-size: 16px;
      padding: 0px 27px;
      color: #fff;
      background-color: #0da982;
      border-radius: 15px;
      border: none;
      margin: auto;
      cursor: pointer;

      &:hover {
        background-color: #0da982;
      }
    }
  }
`;